class EventHandlerUtility {
  constructor() {
    // Словарь для хранения обработчиков событий
    this.handlers = new Map();
  }

  // Регистрация обработчика для определённого события
  registerHandler(eventName, handler) {
    if (!this.handlers.has(eventName)) {
      this.handlers.set(eventName, []);
    }
    this.handlers.get(eventName).push(handler);
  }

  // Уведомление всех обработчиков при возникновении события
  trigger(eventName, ...args) {
    if (this.handlers.has(eventName)) {
      this.handlers.get(eventName).forEach((handler) => handler(...args));
    }
  }

  // Удаление обработчика для определённого события
  removeHandler(eventName, handler) {
    if (this.handlers.has(eventName)) {
      const handlers = this.handlers.get(eventName);
      this.handlers.set(eventName, handlers.filter((h) => h !== handler));
    }
  }
}

export default EventHandlerUtility